<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
              <div class="card-body p-2">
                <div class=" mb-2 d-flex justify-content-between">
                  <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i
                        class="mdi mdi-undo"></i> Back</a></span>
                  <span v-if="canEditPsychologyPatient"><a @click="openEditModal" type="button" class="btn-sm btn btn-primary"> <i
                        class="mdi mdi-pencil"></i> Edit</a></span>
                </div>
                <span v-if="!patientspinner && patients.length">
                  <div v-for="item in patients" :key="item.id" class="patient-bio">
                    <img v-if="item.photo" class="patient-bio-photo" :src="getPhotos(item.photo)" alt="Patient photo" />
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Full Name</span>
                      <span class="text-primary fw-semibold">{{ item.full_name }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Gender</span>
                      <span class="text-primary">{{ item.gender }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Current Age</span>
                      <span class="text-primary">{{ item.age }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Marital Status</span>
                      <span class="text-primary">{{ item.marital_status }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Address</span>
                      <span class="text-primary">{{ item.address }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Nationality</span>
                      <span class="text-primary">{{ item.nationality }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Residential Status</span>
                      <span class="text-primary">{{ item.residential_status }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Highest Education</span>
                      <span class="text-primary">{{ item.education }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Occupation</span>
                      <span class="text-primary">{{ item.occupation }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Siblings</span>
                      <span class="text-primary">
                        <span v-if="item.siblings">{{ item.siblings }}</span>
                        <span v-else class="text-muted">-</span>
                      </span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Referred By</span>
                      <span class="text-primary">{{ item.referred_by }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Psychology Section</span>
                      <span class="text-primary">{{ item.psychology_category_name || 'Psychology Consultations' }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Psychology Service</span>
                      <span class="text-primary">{{ item.psychology_service_name || '-' }}</span>
                    </div>
                    <div class="patient-bio-row" v-if="item.test_type">
                      <span class="patient-bio-label">Test Type</span>
                      <span class="text-primary">{{ item.test_type }}</span>
                    </div>
                    <div class="patient-bio-row" v-if="item.company_name">
                      <span class="patient-bio-label">Company</span>
                      <span class="text-primary">{{ item.company_name }}</span>
                    </div>
                    <div class="patient-bio-row" v-if="item.employee_coverage !== null && item.employee_coverage !== ''">
                      <span class="patient-bio-label">Employees Covered</span>
                      <span class="text-primary">{{ item.employee_coverage }}</span>
                    </div>
                    <div class="patient-bio-row" v-if="item.psychology_extra_info">
                      <span class="patient-bio-label">Extra Information</span>
                      <span class="text-primary">{{ item.psychology_extra_info }}</span>
                    </div>
                    <div class="patient-bio-row">
                      <span class="patient-bio-label">Date of Registration</span>
                      <span class="text-primary">{{ item.date_of_registration }}</span>
                    </div>
                  </div>
                </span>
                <span v-else-if="patientspinner"><i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i></span>
                <span v-else class="text-muted p-2 d-block">No patient bio data found.</span>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <b-tabs pills nav-class="p-0" content-class="text-dark">
              <b-tab active class="border-0">
                <template v-slot:title>Presentation</template>
                <div class="card">
                  <div class="card-body">
                    <form v-show="showPresentationForm" @submit.prevent="addPresentation">
                      <div class="row g-3">
                        <div class="col-12">
                          <div class="form-group mb-0">
                            <h6 class="mb-3 text-primary">Cognitive & Affective Tone</h6>

                            <label class="mb-0 form-label">Interaction Style</label>
                            <select v-model.number="interactionStyle" class="form-select">
                              <option :value="null" disabled>Select interaction</option>
                              <option :value="1">Dramatic</option>
                              <option :value="2">Sensitive</option>
                              <option :value="3">Cooperative</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-12">

                          <div class="form-group mb-3">
                            <label class="mb-0 form-label">Eye Contact</label>
                            <select v-model.number="eyeContact" class="form-select">
                              <option :value="1">None</option>
                              <option :value="2">Normal</option>
                              <option :value="3">Avoidant</option>
                              <option :value="4">Poor</option>
                            </select>
                          </div>

                          <div class="form-group mb-3">
                            <label class="mb-0 form-label">Memory</label>
                            <select v-model.number="memoryStatus" class="form-select">
                              <option :value="1">Normal</option>
                              <option :value="2">Impaired</option>
                            </select>
                          </div>

                          <div class="form-group mb-3">
                            <label class="mb-0 form-label">Affective Tone</label>
                            <select v-model.number="affectiveTone" class="form-select">
                              <option :value="null" disabled>Select affective tone</option>
                              <option :value="1">Normal</option>
                              <option :value="2">Labile</option>
                              <option :value="3">Blunted</option>
                              <option :value="4">Indifferent</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <h6 class="mb-3 text-primary">Mental State Examination</h6>
                      <div class="form-group mb-3">
                        <label class="mb-0 form-label">Mood</label>
                        <Editor :key="'mood-' + presentationKey" id="mood-editor" v-model="mood"></Editor>
                      </div>

                      <div class="form-group mb-3">
                        <label class="mb-0 form-label">Appearance and Hygiene</label>
                        <Editor :key="'appearance-' + presentationKey" id="appearance-editor"
                          v-model="appearanceHygiene"></Editor>
                      </div>


                      <div class="form-group mt-3 d-flex justify-content-end">
                        <b-button type="submit" class="btn" variant="primary">
                          <i class="fas fa-check-circle"></i> Save Presentation
                        </b-button>
                      </div>
                    </form>
                    <div v-show="!showPresentationForm" class="text-center py-4">
                      <p class="text-muted mb-3">No presentation data available.</p>
                      <b-button type="button" variant="primary" @click="showPresentationForm = true">
                        Add Presentation
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Treatment</template>
                <div class="card">
                  <div class="card-body">
                    <form v-show="showTreatmentForm" @submit.prevent="addTreatment">
                      <div class="form-group mb-3">
                        <label class="mb-0 form-label">Patient Complaints</label>
                        <Editor id="complaints-editor" v-model="complaints"></Editor>
                      </div>

                      <div class="form-group mb-3">
                        <label class="mb-0 form-label">History/Anamnesis</label>
                        <Editor id="anamnesis-editor" v-model="anamnesis"></Editor>
                      </div>

                      <div class="form-group mb-3">
                        <label class="mb-0 form-label">History/Antecedents</label>
                        <Editor id="antecedents-editor" v-model="antecedents"></Editor>
                      </div>

                      <h4 class="my-4 text-primary">Symptomatological Evaluation</h4>
                      <h5 class="text-primary">Psychological Pole</h5>

                      <div class="row">
                        <div class="col-6 form-group mb-3">
                          <label class="mb-0 form-label">Cognitive Observation/Symptoms</label>
                          <Editor id="cognitive-symptoms-editor" v-model="cognitive_symptoms"></Editor>
                        </div>

                        <div class="col-6 form-group mb-3">
                          <label class="mb-0 form-label">Affective Observation/Symptoms</label>
                          <Editor id="affective-symptoms-editor" v-model="affective_symptoms"></Editor>
                        </div>
                      </div>

                      <h5 class="text-primary">Somatic and Expressive Pole</h5>

                      <div class="row">
                        <div class="col-6 form-group mb-3">
                          <label class="mb-0 form-label">Psychomotor</label>
                          <Editor id="psychomotor-editor" v-model="psychomotor"></Editor>
                        </div>

                        <div class="col-6 form-group mb-3">
                          <label class="mb-0 form-label">Vital Functions</label>
                          <Editor id="vital-functions-editor" v-model="vital_functions"></Editor>
                        </div>
                      </div>

                      <h5 class="text-primary">Relational Pole</h5>

                      <div class="row">
                        <div class="col-6 form-group mb-3">
                          <label class="mb-0 form-label">Behavioral Symptoms</label>
                          <Editor id="behavioral-symptoms-editor" v-model="behavioral_symptoms"></Editor>
                        </div>

                        <div class="col-6 form-group mb-3">
                          <label class="mb-0 form-label">Social Symptoms</label>
                          <Editor id="social-symptoms-editor" v-model="social_symptoms"></Editor>
                        </div>
                      </div>


                      <div class="form-group mb-3">
                        <label class="mb-0 form-label">Diagnosis</label>
                        <Editor id="diagnosis-editor" v-model="diagnosis"></Editor>
                      </div>

                      <div class="form-group d-flex justify-content-between mt-3">
                        <b-button type="submit" class="btn ms-1" variant="primary"><i class="fas fa-check-circle"></i>
                          Submit</b-button>
                      </div>
                    </form>
                    <div v-show="!showTreatmentForm" class="text-center py-4">
                      <p class="text-muted mb-3">No treatment data available.</p>
                      <b-button type="button" variant="primary" @click="showTreatmentForm = true">
                        Add Treatment
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Assessment</template>
                <div class="card">
                  <div class="card-body">
                    <form v-show="showAssessmentForm" @submit.prevent="AddAssessment">
                      <div class="d-flex align-items-center gap-3 rounded mb-4">
                        <span class="h4 mb-0">CGI <br> Score: </span>
                        <div class="d-flex justify-content-between flex-grow-1 gap-2">
                          <button type="button" v-for="i in range(7)" :key="i" class="px-2 btn fw-bold"
                            :class="cgi_score === i + 1 ? 'btn-primary' : 'btn-outline-primary'"
                            @click="cgi_score = i + 1"
                            style="min-width: 2.5rem; height: 2.5rem; align-items: center; justify-content: center; font-size: 1.1rem;">
                            {{ i + 1 }} <span v-if="i == cgi_score - 1">{{ getCGILabel }}</span>
                          </button>
                        </div>
                      </div>

                      <hr>

                      <div class="d-flex align-items-center gap-3 rounded mb-4">
                        <span class="h4 mb-0">PHQ Score: </span>
                        <div class="row">
                          <div class="col-4 phq-group mb-3">
                            <div class="group-label">None (0-4)</div>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button" v-for="i in range(5)" :key="i" class="px-2 btn btn-sm"
                                :class="phq_score === i ? 'btn-success' : 'btn-outline-success'" @click="phq_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>

                          <div class="col-4 phq-group mb-3">
                            <div class="group-label">Borderline (5-9)</div>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button" v-for="i in range(5, 10)" :key="i" class="px-2 btn btn-sm"
                                :class="phq_score === i ? 'btn-success' : 'btn-outline-success'" @click="phq_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>

                          <div class="col-4 phq-group mb-3">
                            <div class="group-label">Moderate (10-14)</div>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button" v-for="i in range(10, 15)" :key="i" class="px-2 btn btn-sm"
                                :class="phq_score === i ? 'btn-success' : 'btn-outline-success'" @click="phq_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>

                          <div class="phq-group">
                            <div class="group-label">Severe (15+)</div>
                            <div class="d-flex justify-content-between">
                              <button type="button" v-for="i in range(15, 28)" :key="i" class="px-2 btn btn-sm"
                                :class="phq_score === i ? 'btn-success' : 'btn-outline-success'" @click="phq_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr>

                      <div class="d-flex align-items-center gap-3 rounded mb-4">
                        <span class="h4 mb-0">GAD <br> Score: </span>
                        <div class="row">
                          <div class="col-4 gad-group mb-3">
                            <div class="group-label">None (0-4)</div>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button" v-for="i in range(5)" :key="i" class="px-2 btn btn-sm"
                                :class="gad_score === i ? 'btn-warning' : 'btn-outline-warning'" @click="gad_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>

                          <div class="col-4 gad-group mb-3">
                            <div class="group-label">Borderline (5-9)</div>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button" v-for="i in range(5, 10)" :key="i" class="px-2 btn btn-sm"
                                :class="gad_score === i ? 'btn-warning' : 'btn-outline-warning'" @click="gad_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>

                          <div class="col-4 gad-group mb-3">
                            <div class="group-label">Moderate (10-14)</div>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button" v-for="i in range(10, 15)" :key="i" class="px-2 btn btn-sm"
                                :class="gad_score === i ? 'btn-warning' : 'btn-outline-warning'" @click="gad_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>

                          <div class="gad-group">
                            <div class="group-label">Severe (15+)</div>
                            <div class="d-flex justify-content-between">
                              <button type="button" v-for="i in range(15, 22)" :key="i" class="px-2 btn btn-sm"
                                :class="gad_score === i ? 'btn-warning' : 'btn-outline-warning'" @click="gad_score = i"
                                style="min-width: 2.2rem; height: 2.2rem; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 0.8rem; font-weight: 600;">{{
                                  i }}</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr>

                      <div class="d-flex align-items-center gap-3 rounded mb-4">
                        <span class="h4 mb-0">PCSI <br> Score: </span>
                        <div class="d-flex justify-content-between flex-grow-1 gap-2">
                          <button type="button" class="px-3 btn btn-sm"
                            :class="pcsi_score === 1 ? 'btn-dark' : 'btn-outline-dark'" @click="pcsi_score = 1"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Non-significant
                          </button>
                          <button type="button" class="px-3 btn btn-sm"
                            :class="pcsi_score === 2 ? 'btn-dark' : 'btn-outline-dark'" @click="pcsi_score = 2"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Presence of Symptoms
                          </button>
                          <button type="button" class="px-3 btn btn-sm"
                            :class="pcsi_score === 3 ? 'btn-dark' : 'btn-outline-dark'" @click="pcsi_score = 3"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Probable PTSD
                          </button>
                        </div>
                      </div>

                      <hr class="mt-4 mb-4">

                      <div class="form-group d-flex justify-content-end">
                        <b-button type="submit" class="btn" variant="primary">
                          <i class="fas fa-check-circle"></i> Save Assessment
                        </b-button>
                      </div>
                    </form>
                    <div v-show="!showAssessmentForm" class="text-center py-4">
                      <p class="text-muted mb-3">No assessment data available.</p>
                      <b-button type="button" variant="primary" @click="showAssessmentForm = true">
                        Add Assessment
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Therapeutics</template>
                <div class="card">
                  <div class="card-body">
                    <!-- Existing Therapeutic Plans Table -->
                    <div v-if="therapeuticPlans.length" class="mb-4">
                      <h6 class="mb-3 text-primary">Therapy Sessions</h6>

                      <div class="table-responsive">
                        <b-table :items="therapeuticPlans" :fields="therapyFields" responsive="sm"
                          class="table-sm table-hover mb-0" thead-class="table-light"
                          :tbody-tr-class="getTherapyRowClass">
                          <template #cell(name)="data">
                            <span class="fw-medium">Therapy {{ getTherapyNumber(data.index) }}</span>
                          </template>

                          <template #cell(addedby)="data">
                            {{ data.item.addedby || '-' }}
                          </template>

                          <template #cell(created_at)="data">
                            {{ data.item.created_at || '-' }}
                          </template>

                          <template #cell(actions)="data">
                            <button class="btn btn-sm btn-info me-1" @click="openShowTherapyModal(data.item)"
                              title="Edit">
                              <i class="mdi mdi-text-box-outline"></i>
                            </button>
                            <button v-if="canDeletePsychologyPatient" class="btn btn-sm btn-danger" @click="deleteTherapeuticPlan(data.item.id)"
                              title="Delete">
                              <i class="mdi mdi-delete"></i>
                            </button>
                          </template>
                        </b-table>
                      </div>
                    </div>

                    <!-- Add New Therapy Button -->
                    <div v-if="therapeuticPlans.length" class="text-center my-3">
                      <b-button type="button" variant="primary" @click="openAddTherapyModal">
                        <i class="fas fa-plus"></i> Add New Therapy Session
                      </b-button>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!therapeuticPlans.length" class="text-center py-4">
                      <p class="text-muted mb-3">No therapy sessions added yet.</p>
                      <b-button type="button" variant="primary" @click="openAddTherapyModal">
                        <i class="fas fa-plus"></i> Add Therapy Session
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>Follow ups</template>
                <div class="card">
                  <div class="card-body">
                    <!-- Existing Follow Ups Table -->
                    <div v-if="followUps.length" class="mb-4">
                      <h6 class="mb-3 text-primary">Follow Up & Progress</h6>

                      <div class="table-responsive">
                        <b-table :items="followUps" :fields="followUpFields" responsive="sm"
                          class="table-sm table-hover mb-0" thead-class="table-light">
                          <template #cell(name)="data">
                            <span class="fw-medium">Follow up {{ getFollowUpNumber(data.index) }}</span>
                          </template>

                          <template #cell(addedby)="data">
                            {{ data.item.addedby || '-' }}
                          </template>

                          <template #cell(created_at)="data">
                            {{ data.item.created_at || '-' }}
                          </template>

                          <template #cell(actions)="data">
                            <button class="btn btn-sm btn-info me-1" @click="openShowFollowUpModal(data.item)"
                              title="View">
                              <i class="mdi mdi-text-box-outline"></i>
                            </button>
                            <button v-if="canDeletePsychologyPatient" class="btn btn-sm btn-danger" @click="deleteFollowUp(data.item.id)" title="Delete">
                              <i class="mdi mdi-delete"></i>
                            </button>
                          </template>
                        </b-table>
                      </div>
                    </div>

                    <!-- Add New Follow Up Button -->
                    <div v-if="followUps.length" class="text-center my-3">
                      <b-button type="button" variant="primary" @click="openAddFollowUpModal">
                        <i class="fas fa-plus"></i> Add New Follow Up
                      </b-button>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!followUps.length" class="text-center py-4">
                      <p class="text-muted mb-3">No follow up sessions added yet.</p>
                      <b-button type="button" variant="primary" @click="openAddFollowUpModal">
                        <i class="fas fa-plus"></i> Add Follow Up
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab class="border-0">
                <template v-slot:title>End of Cycle</template>
                <div class="card">
                  <div class="card-body">
                    <form v-show="showEndOfCycleForm" @submit.prevent="AddEndOfCycle">
                      <div class="d-flex align-items-center gap-3 rounded mb-4">
                        <span class="h5 mb-0">Progress:</span>
                        <div class="d-flex gap-2">
                          <button type="button" class="px-3 btn"
                            :class="progress === 1 ? 'btn-success' : 'btn-outline-success'" @click="progress = 1"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Stable
                          </button>
                          <button type="button" class="px-3 btn"
                            :class="progress === 2 ? 'btn-primary' : 'btn-outline-primary'" @click="progress = 2"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Improvement
                          </button>
                          <button type="button" class="px-3 btn"
                            :class="progress === 3 ? 'btn-warning' : 'btn-outline-warning'" @click="progress = 3"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Regression
                          </button>
                        </div>
                      </div>

                      <hr>

                      <div class="d-flex align-items-center gap-3 rounded mb-4">
                        <span class="h5 mb-0">Engagement:</span>
                        <div class="d-flex gap-2">
                          <button type="button" class="px-3 btn"
                            :class="engagement === 1 ? 'btn-success' : 'btn-outline-success'" @click="engagement = 1"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            High
                          </button>
                          <button type="button" class="px-3 btn"
                            :class="engagement === 2 ? 'btn-warning' : 'btn-outline-warning'" @click="engagement = 2"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Moderate
                          </button>
                          <button type="button" class="px-3 btn"
                            :class="engagement === 3 ? 'btn-danger' : 'btn-outline-danger'" @click="engagement = 3"
                            style="padding: 0.5rem 1rem; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 600;">
                            Fragile
                          </button>
                        </div>
                      </div>

                      <hr>

                      <div class="form-group mb-3">
                        <label class="mb-0 form-label fw-medium text-primary">Synthesis Note</label>
                        <Editor id="cycle-editor" v-model="synthesis_notes" />
                      </div>

                      <hr class="mt-4 mb-4">

                      <div class="form-group d-flex justify-content-end">
                        <b-button type="submit" class="btn" variant="primary">
                          <i class="fas fa-check-circle"></i> Save End of Cycle
                        </b-button>
                      </div>
                    </form>
                    <div v-show="!showEndOfCycleForm" class="text-center py-4">
                      <p class="text-muted mb-3">No end of cycle data available.</p>
                      <b-button type="button" variant="primary" @click="showEndOfCycleForm = true">
                        Add End of Cycle
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab>
                <template v-slot:title>Patient Logs</template>
                <div class="card">
                  <div class="card-body">
                    <!-- Filters -->
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <h6 class="mb-0 text-primary">Activity Timeline</h6>
                      <div class="d-flex gap-2">
                        <select v-model="logFilterModule" class="form-select form-select-sm" style="width: auto;">
                          <option value="">All Modules</option>
                          <option value="1">Presentation</option>
                          <option value="2">Assessment</option>
                          <option value="3">Treatment</option>
                          <option value="4">Therapeutic Plan</option>
                          <option value="5">Follow up</option>
                          <option value="6">End of Cycle</option>
                        </select>
                        <select v-model="logFilterAction" class="form-select form-select-sm" style="width: auto;">
                          <option value="">All Actions</option>
                          <option value="Created">Created</option>
                          <option value="Updated">Updated</option>
                          <option value="Deleted">Deleted</option>
                        </select>
                        <button v-if="logFilterModule || logFilterAction" @click="resetLogFilters"
                          class="btn btn-sm btn-secondary" title="Reset Filters">
                          <i class="mdi mdi-filter-off"></i> Reset
                        </button>
                      </div>
                    </div>

                    <div class="logs-scroll">
                      <!-- Timeline -->
                      <div v-if="filteredLogs.length" class="activity-timeline">
                        <div v-for="log in filteredLogs" :key="log.id" class="timeline-item">
                          <div class="timeline-marker" :class="getModuleClass(log.module)">
                            <i :class="getModuleIcon(log.module)"></i>
                          </div>
                          <div class="timeline-content">
                            <div class="timeline-card compact-log" :class="getActionBorderClass(log.action)">
                              <div class="d-flex justify-content-between align-items-center mb-1 timeline-header">
                                <div class="d-flex align-items-center flex-wrap gap-2">
                                  <span class="badge" :class="getModuleBadgeClass(log.module)">{{
                                    getModuleName(log.module) }}</span>
                                  <span class="badge" :class="getActionBadgeClass(log.action)">{{ log.action
                                    }}</span>
                                  <span v-if="log.details" class="text-muted log-inline">{{ log.details }}</span>
                                </div>
                                <small class="text-muted">
                                  <i class="mdi mdi-clock-outline"></i> {{ log.created_at }}
                                </small>
                              </div>
                              <div class="log-details compact-log-details">
                                <div class="d-flex align-items-center">
                                  <i class="mdi mdi-account-circle text-primary me-2" style="font-size: 1.1rem;"></i>
                                  <span class="fw-medium">{{ log.user || 'Unknown User' }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Empty State -->
                      <div v-else-if="!isLoadingLogs" class="text-center py-5">
                        <i class="mdi mdi-history text-muted" style="font-size: 3rem;"></i>
                        <p class="text-muted mt-3 mb-0">No activity logs found for this patient.</p>
                      </div>

                      <!-- Loading State -->
                      <div v-if="isLoadingLogs" class="text-center py-5">
                        <i class="fas fa-spinner fa-spin text-primary" style="font-size: 2rem;"></i>
                        <p class="text-muted mt-3">Loading logs...</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Therapy Session Modal -->
    <b-modal id="new-therapy-modal" title="Add New Therapy Session" size="lg" hide-footer>
      <form @submit.prevent="addTherapeuticPlan">
        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Therapy Notes</label>
          <textarea class="form-control fw-medium" rows="4" style="font-size: medium;" v-model="newTherapy"
            placeholder="Therapy Details"></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Counselling On</label>
          <textarea v-model="newCounsellingOn" class="form-control fw-medium" style="font-size: medium;" rows="3"
            placeholder="Details of counselling..."></textarea>
        </div>
        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Referrals/Recommendations</label>
          <textarea v-model="newReferrals" class="form-control fw-medium" style="font-size: medium;" rows="3"
            placeholder="Referrals or recommendations..."></textarea>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" @click="$bvModal.hide('new-therapy-modal')">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="fas fa-check-circle"></i> Save Therapy Session
          </button>
        </div>
      </form>
    </b-modal>

    <!-- Therapy Detail Modal -->
    <b-modal id="therapy-detail" title="Edit Therapy Session" size="lg" hide-footer>
      <form @submit.prevent="updateTherapeuticPlan">
        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Therapy Notes</label>
          <textarea class="form-control fw-medium" rows="4" style="font-size: medium;" v-model="newTherapy"
            placeholder="Therapy Details"></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Counselling On</label>
          <textarea v-model="newCounsellingOn" class="form-control fw-medium" style="font-size: medium;" rows="3"
            placeholder="Details of counselling..."></textarea>
        </div>
        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Referrals/Recommendations</label>
          <textarea v-model="newReferrals" class="form-control fw-medium" style="font-size: medium;" rows="3"
            placeholder="Referrals or recommendations..."></textarea>
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" @click="$bvModal.hide('therapy-detail')">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="fas fa-check-circle"></i> Update Therapy Session
          </button>
        </div>
      </form>
    </b-modal>

    <!-- Add Follow Up Modal -->
    <b-modal id="new-followup-modal" title="Add New Follow Up" size="lg" hide-footer>
      <form @submit.prevent="addFollowUp">
        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Date</label>
          <input type="date" class="form-control" v-model="newFollowUpDate" required />
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Problems/Complaints</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpComplaints"
            placeholder="Patient complaints..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Therapy</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpTherapy"
            placeholder="Therapy provided..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Technique</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpTechnique"
            placeholder="Technique used..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Observation</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpObservation"
            placeholder="Observations..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Duration</label>
          <input class="form-control" v-model="newFollowUpDuration" placeholder="Duration" />
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" @click="$bvModal.hide('new-followup-modal')">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="fas fa-check-circle"></i> Save Follow Up
          </button>
        </div>
      </form>
    </b-modal>

    <!-- Follow Up Detail Modal -->
    <b-modal id="followup-detail" title="Edit Follow Up" size="lg" hide-footer>
      <form @submit.prevent="updateFollowUp">
        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Date</label>
          <input type="date" class="form-control" v-model="newFollowUpDate" required />
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Problems/Complaints</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpComplaints"
            placeholder="Patient complaints..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Therapy</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpTherapy"
            placeholder="Therapy provided..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Technique</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpTechnique"
            placeholder="Technique used..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Observation</label>
          <textarea class="form-control fw-medium" rows="3" style="font-size: medium;" v-model="newFollowUpObservation"
            placeholder="Observations..."></textarea>
        </div>

        <div class="form-group mb-3">
          <label class="mb-0 form-label fw-medium text-primary">Duration</label>
          <input class="form-control" v-model="newFollowUpDuration" placeholder="Duration" />
        </div>

        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-secondary" @click="$bvModal.hide('followup-detail')">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="fas fa-check-circle"></i> Update Follow Up
          </button>
        </div>
      </form>
    </b-modal>

    <EditPatientModal ref="editPatientModal" :patientId="patient_id" @patient-updated="onPatientUpdated" />
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import EditPatientModal from "./edit_patient.vue";
import Swal from "sweetalert2";
import Editor from "vue-tinymce-editor";

export default {
  page: {
    title: "Psycho Patient Profile",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, EditPatientModal, Editor
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")) || { permissions: {}, settings: {} },
      title: "Patient Profile",
      items: [{ text: "Dashboard", to: "/", }, { text: "Psycho Patients", to: "/psychology" }, { text: "Patient Profile", active: true, },],
      patients: [],
      patientspinner: true,
      patient_id: null,
      siblingsExpanded: {},
      maxSiblingsPreview: 3,
      // Empty state toggles
      showPresentationForm: false,
      showTreatmentForm: false,
      showAssessmentForm: false,
      showEndOfCycleForm: false,
      // Presentation tab data
      mood: "",
      appearanceHygiene: "",
      interactionStyle: null,
      eyeContact: 1,
      memoryStatus: 1,
      affectiveTone: null,
      presentationKey: 0,
      // Treatment tab data
      complaints: "",
      anamnesis: "",
      antecedents: "",
      cognitive_symptoms: "",
      affective_symptoms: "",
      psychomotor: "",
      vital_functions: "",
      behavioral_symptoms: "",
      social_symptoms: "",
      diagnosis: "",
      patient_type: "1",
      // Assessment tab data
      cgi_score: 0,
      phq_score: 0,
      gad_score: 0,
      pcsi_score: 0,
      // End of Cycle tab data
      progress: 0,
      engagement: 0,
      synthesis_notes: "",
      // Therapeutic Plan tab data
      therapeuticPlans: [],
      therapy_id: null,
      newTherapy: "",
      newCounsellingOn: "",
      newReferrals: "",
      isLoadingTherapeuticPlans: false,
      showTherapyEditor: false,

      showEditTherapyEditor: false,

      therapyFields: [
        { key: 'name', label: '#' },
        { key: 'addedby', label: 'Added By' },
        { key: 'created_at', label: 'Added On' },
        { key: 'actions', label: 'Actions', thStyle: { width: '120px' } },
      ],

      // Follow Up tab data
      followUps: [],
      followup_id: null,
      newFollowUpDate: "",
      newFollowUpComplaints: "",
      newFollowUpTherapy: "",
      newFollowUpTechnique: "",
      newFollowUpObservation: "",
      newFollowUpDuration: "",
      isLoadingFollowUps: false,

      followUpFields: [
        { key: 'name', label: '#' },
        { key: 'addedby', label: 'Added By' },
        { key: 'created_at', label: 'Added On' },
        { key: 'actions', label: 'Actions', thStyle: { width: '120px' } },
      ],
      // Patient Logs tab data
      patientLogs: [],
      isLoadingLogs: false,
      logFilterModule: '',
      logFilterAction: '',
    };
  },
  computed: {
    isAdministrator() {
      return (this.userData?.role || "").toString().toLowerCase() === "administrator";
    },
    canEditPsychologyPatient() {
      return this.isAdministrator || this.userData?.permissions?.['edit_psychology_patient'] == 1;
    },
    canDeletePsychologyPatient() {
      return this.isAdministrator || this.userData?.permissions?.['delete_psychology_patient'] == 1;
    },
    getCGILabel() {
      if (this.cgi_score == 1) return "Normal";
      if (this.cgi_score == 2) return "Borderline";
      if (this.cgi_score == 3) return "Mild";
      if (this.cgi_score == 4) return "Moderate";
      if (this.cgi_score == 5) return "Marked";
      if (this.cgi_score == 6) return "Severe";
      if (this.cgi_score == 7) return "Extreme";
      return null;
    },
    filteredLogs() {
      let logs = this.patientLogs;
      if (this.logFilterModule) {
        logs = logs.filter(log => String(log.module) === String(this.logFilterModule));
      }
      if (this.logFilterAction) {
        logs = logs.filter(log => log.action === this.logFilterAction);
      }
      return logs;
    },
  },

  methods: {
    range(start, end = null) {
      if (end === null) {
        return Array.from({ length: start }, (_, i) => i);
      }
      return Array.from({ length: end - start }, (_, i) => i + start);
    },
    isSiblingsExpanded(patientId) {
      return !!this.siblingsExpanded[patientId];
    },
    toggleSiblings(patientId) {
      this.$set(this.siblingsExpanded, patientId, !this.isSiblingsExpanded(patientId));
    },
    getSiblingsPreview(item) {
      if (!item || !Array.isArray(item.siblings)) {
        return "";
      }
      if (this.isSiblingsExpanded(item.id)) {
        return item.siblings.join(", ");
      }
      return item.siblings.slice(0, this.maxSiblingsPreview).join(", ");
    },
    openEditModal() {
      if (this.$refs.editPatientModal) {
        this.$refs.editPatientModal.show();
      }
    },
    openAddTherapyModal() {
      this.newTherapy = "";
      this.newCounsellingOn = "";
      this.newReferrals = "";
      this.therapy_id = null;
      this.$bvModal.show("new-therapy-modal");
    },

    openShowTherapyModal(therapy) {
      this.newTherapy = therapy.therapy || "";
      this.newCounsellingOn = therapy.counselling_on || "";
      this.newReferrals = therapy.referrals || "";
      this.therapy_id = therapy.id;
      this.$bvModal.show("therapy-detail");
    },

    async onPatientUpdated() {
      // Force a fresh fetch so edited bio values are reflected immediately.
      await this.loadPatientBio(true);
    },
    async fetchPatientBioById(patientId) {
      if (!patientId) return false;

      const response = await axios.get(`/psycho-patient-bio/${patientId}`);
      const patientData = response.data.psychopatients || response.data.psychopatient || response.data.patient;

      if (!patientData) {
        return false;
      }

      this.patients = Array.isArray(patientData) ? patientData : [patientData];
      if (this.patients[0] && this.patients[0].id) {
        this.patient_id = this.patients[0].id;
        sessionStorage.setItem("psychoPatientBio", JSON.stringify(this.patients[0]));
      }

      return true;
    },
    async addPresentation() {
      try {
        const payload = new FormData();
        payload.append("id", this.patient_id);
        payload.append("mood", this.mood);
        payload.append("appearance", this.appearanceHygiene);
        payload.append("interaction_style", this.interactionStyle ?? "");
        payload.append("eye_contact", this.eyeContact);
        payload.append("memory", this.memoryStatus);
        payload.append("affection_tone", this.affectiveTone ?? "");

        const response = await axios.post("/update-psycho-patient-presentation", payload);
        if (response.status == 200) {
          this.showPresentationForm = true;
          Swal.fire({
            title: "Success!",
            text: "Presentation data saved successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to save presentation data",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },
    async addTreatment() {
      try {
        const payload = new FormData();
        payload.append("id", this.patient_id);
        payload.append("complaints", this.complaints);
        payload.append("anamnesis", this.anamnesis);
        payload.append("antecedents", this.antecedents);
        payload.append("cognitive_symptoms", this.cognitive_symptoms);
        payload.append("affective_symptoms", this.affective_symptoms);
        payload.append("psychomotor", this.psychomotor);
        payload.append("vital_functions", this.vital_functions);
        payload.append("behavioral_symptoms", this.behavioral_symptoms);
        payload.append("social_symptoms", this.social_symptoms);
        payload.append("diagnosis", this.diagnosis);
        payload.append("patient_type", this.patient_type);

        const response = await axios.post("/update-psycho-patient-treatment", payload);
        if (response.status == 200) {
          this.showTreatmentForm = true;
          Swal.fire({
            title: "Success!",
            text: "Treatment data saved successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
          // Reload treatment data to reflect changes
          await this.loadTreatmentData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to save treatment data",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },
    async AddAssessment() {
      try {
        const payload = new FormData();
        payload.append("id", this.patient_id);
        payload.append("cgi_score", this.cgi_score);
        payload.append("phq_score", this.phq_score);
        payload.append("gad_score", this.gad_score);
        payload.append("pcsi_score", this.pcsi_score);

        const response = await axios.post("/update-psycho-patient-assessment", payload);
        if (response.status == 200) {
          this.showAssessmentForm = true;
          Swal.fire({
            title: "Success!",
            text: "Assessment data saved successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
          // Reload assessment data to reflect changes
          await this.loadAssessmentData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to save assessment data",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },
    async loadPatientBio(forceRefresh = false) {
      // Step 1: Load basic patient information
      const statePatient = (this.$route && this.$route.state && this.$route.state.patient)
        ? this.$route.state.patient
        : (window.history.state && window.history.state.patient ? window.history.state.patient : null);
      const routeId = this.$route && this.$route.query ? this.$route.query.id : null;
      const currentId = this.patient_id || routeId || (statePatient && statePatient.id) || null;

      if (forceRefresh) {
        try {
          await this.fetchPatientBioById(currentId);
        } catch (error) {
          // Keep current UI data if refresh fails.
        } finally {
          this.patientspinner = false;
        }
      } else if (statePatient) {
        this.patients = Array.isArray(statePatient) ? statePatient : [statePatient];
        if (statePatient.id) {
          this.patient_id = statePatient.id;
        }
        this.patientspinner = false;
      } else {
        if (!routeId) {
          this.patientspinner = false;
          return false;
        }

        const cachedPatient = sessionStorage.getItem("psychoPatientBio");
        if (cachedPatient) {
          const parsed = JSON.parse(cachedPatient);
          if (parsed && parsed.id && String(parsed.id) === String(routeId)) {
            this.patients = [parsed];
            this.patient_id = parsed.id;
            this.patientspinner = false;
          } else {
            try {
              await this.fetchPatientBioById(routeId);
            } catch (error) {
              // Ignore and preserve existing UI state.
            } finally {
              this.patientspinner = false;
            }
          }
        } else {
          try {
            await this.fetchPatientBioById(routeId);
            this.patientspinner = false;
          } catch (error) {
            this.patientspinner = false;
          }
        }
      }

      // Step 2: Load all tab data if patient_id is available
      if (this.patient_id) {
        this.showPresentationForm = false;
        this.showTreatmentForm = false;
        this.showAssessmentForm = false;
        this.showEndOfCycleForm = false;
        await Promise.all([
          this.loadPresentationData(),
          this.loadTreatmentData(),
          this.loadAssessmentData(),
          this.loadTherapeuticPlanData(),
          this.loadFollowUpData(),
          this.loadEndOfCycleData(),
          this.loadPatientLogs(),
        ]);
      }

      return !!this.patient_id;
    },

    // Load Presentation tab data
    async loadPresentationData() {
      if (!this.patient_id) return;

      try {
        const response = await axios.get(`/psycho-patient-presentation/${this.patient_id}`);
        const rawPresentation = response.data.presentation || null;
        if (!rawPresentation) {
          return;
        }
        this.showPresentationForm = true;
        this.mood = rawPresentation.mood || "";
        this.appearanceHygiene = rawPresentation.appearance || "";
        this.interactionStyle = rawPresentation.interaction_style_id || null;
        this.eyeContact = rawPresentation.eye_contact_id || 1;
        this.memoryStatus = rawPresentation.memory_id || 1;
        this.affectiveTone = rawPresentation.affection_tone_id || null;

      } catch (error) {
        this.$swal("Error loading presentation data:", error);
      }
    },

    // Load Treatment tab data
    async loadTreatmentData() {
      if (!this.patient_id) return;

      try {
        const response = await axios.get(`/psycho-patient-treatment/${this.patient_id}`);
        const rawTreatment = response.data || {};
        const treatmentData = Object.prototype.hasOwnProperty.call(rawTreatment, "treatment")
          ? rawTreatment.treatment
          : rawTreatment;
        const hasTreatmentData = !!(treatmentData && Object.keys(treatmentData).length);
        this.showTreatmentForm = this.showTreatmentForm || hasTreatmentData;

        if (hasTreatmentData) {
          this.complaints = treatmentData.complaints || "";
          this.anamnesis = treatmentData.anamnesis || "";
          this.antecedents = treatmentData.antecedents || "";
          this.cognitive_symptoms = treatmentData.cognitive_symptoms || "";
          this.affective_symptoms = treatmentData.affective_symptoms || "";
          this.psychomotor = treatmentData.psychomotor || "";
          this.vital_functions = treatmentData.vital_functions || "";
          this.behavioral_symptoms = treatmentData.behavioral_symptoms || "";
          this.social_symptoms = treatmentData.social_symptoms || "";
          this.diagnosis = treatmentData.diagnosis || "";
          this.patient_type = treatmentData.patient_type || "1";
        }
      } catch (error) {
        this.$swal("Error loading treatment data:", error);
      }
    },

    // Load Assessment tab data (prescriptions)
    async loadAssessmentData() {
      if (!this.patient_id) return;

      try {
        const response = await axios.get(`/psycho-patient-assessment/${this.patient_id}`);
        const rawAssessment = response.data || {};
        const assessmentData = Object.prototype.hasOwnProperty.call(rawAssessment, "assessment")
          ? rawAssessment.assessment
          : rawAssessment;
        const hasAssessmentData = !!(assessmentData && Object.keys(assessmentData).length);
        this.showAssessmentForm = this.showAssessmentForm || hasAssessmentData;

        if (hasAssessmentData) {
          this.cgi_score = assessmentData.cgi_score || 0;
          this.phq_score = assessmentData.phq_score || 0;
          this.gad_score = assessmentData.gad_score || 0;
          this.pcsi_score = assessmentData.pcsi_score || 0;
        }
      } catch (error) {
        Swal.fire("Error loading assessment data:", error);
      }
    },


    // Load Therapeutic Plan tab data
    async loadTherapeuticPlanData() {
      if (!this.patient_id) return;

      try {
        this.isLoadingTherapeuticPlans = true;
        const response = await axios.get(`/psycho-patient-therapeutic-plan/${this.patient_id}`);
        this.therapeuticPlans = response.data.therapeutic_plans || [];
      } catch (error) {
        Swal.fire("Error loading therapeutic plan data:", error);
      } finally {
        this.isLoadingTherapeuticPlans = false;
      }
    },

    // Add new therapeutic plan
    async addTherapeuticPlan() {
      try {
        const payload = new FormData();
        payload.append("patient_id", this.patient_id);
        payload.append("therapy", this.newTherapy);
        payload.append("counselling_on", this.newCounsellingOn);
        payload.append("referrals", this.newReferrals);

        const response = await axios.post("/update-psycho-patient-therapeutic-plan", payload);
        if (response.status == 200) {
          this.$bvModal.hide("new-therapy-modal");
          Swal.fire({
            title: "Success!",
            text: "Therapeutic plan saved successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
          await this.loadTherapeuticPlanData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to save therapeutic plan",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Update therapeutic plan
    async updateTherapeuticPlan() {
      try {
        const payload = new FormData();
        payload.append("id", this.therapy_id);
        payload.append("patient_id", this.patient_id);
        payload.append("therapy", this.newTherapy);
        payload.append("counselling_on", this.newCounsellingOn);
        payload.append("referrals", this.newReferrals);

        const response = await axios.post("/update-psycho-patient-therapeutic-plan", payload);
        if (response.status == 200) {
          this.$bvModal.hide("therapy-detail");
          Swal.fire({
            title: "Success!",
            text: "Therapeutic plan updated successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
          this.loadTherapeuticPlanData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to update therapeutic plan",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Delete therapeutic plan
    async deleteTherapeuticPlan(therapyId) {
      try {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#556ee6",
          confirmButtonText: "Yes, delete it!",
        });

        if (!result.isConfirmed) return;

        const payload = new FormData();
        payload.append("id", therapyId);

        const response = await axios.post("/delete-psycho-patient-therapeutic-plan", payload);
        if (response.status == 200) {
          Swal.fire({
            title: "Deleted!",
            text: "Therapeutic plan has been deleted.",
            icon: "success",
            confirmButtonColor: "#556ee6",
          });
          await this.loadTherapeuticPlanData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to delete therapeutic plan",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Get row class for therapy highlighting
    getTherapyRowClass(item) {
      if (item && this.hasTherapyContent(item)) {
        return 'table-success therapy-highlighted';
      }
      return '';
    },

    // Check if therapy has counselling or referrals
    hasTherapyContent(therapy) {
      return therapy && (therapy.counselling_on || therapy.referrals);
    },

    // Get therapy number
    getTherapyNumber(index) {
      return index + 1;
    },

    // Follow Up Methods
    openAddFollowUpModal() {
      this.newFollowUpDate = "";
      this.newFollowUpComplaints = "";
      this.newFollowUpTherapy = "";
      this.newFollowUpTechnique = "";
      this.newFollowUpObservation = "";
      this.newFollowUpDuration = "";
      this.followup_id = null;
      this.$bvModal.show("new-followup-modal");
    },

    openShowFollowUpModal(followup) {
      this.newFollowUpDate = followup.date || "";
      this.newFollowUpComplaints = followup.complaints || "";
      this.newFollowUpTherapy = followup.therapy || "";
      this.newFollowUpTechnique = followup.technique || "";
      this.newFollowUpObservation = followup.observation || "";
      this.newFollowUpDuration = followup.duration || "";
      this.followup_id = followup.id;
      this.$bvModal.show("followup-detail");
    },

    // Load Follow Up data
    async loadFollowUpData() {
      if (!this.patient_id) return;

      try {
        this.isLoadingFollowUps = true;
        const response = await axios.get(`/psycho-patient-followup/${this.patient_id}`);
        this.followUps = response.data.follow_ups || [];
      } catch (error) {
        Swal.fire("Error loading follow up data:", error);
      } finally {
        this.isLoadingFollowUps = false;
      }
    },

    // Add new follow up
    async addFollowUp() {
      try {
        const payload = new FormData();
        payload.append("patient_id", this.patient_id);
        payload.append("date", this.newFollowUpDate);
        payload.append("complaints", this.newFollowUpComplaints);
        payload.append("therapy", this.newFollowUpTherapy);
        payload.append("technique", this.newFollowUpTechnique);
        payload.append("observation", this.newFollowUpObservation);
        payload.append("duration", this.newFollowUpDuration);

        const response = await axios.post("/update-psycho-patient-followup", payload);
        if (response.status == 200) {
          this.$bvModal.hide("new-followup-modal");
          Swal.fire({
            title: "Success!",
            text: "Follow up saved successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
          await this.loadFollowUpData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to save follow up",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Update follow up
    async updateFollowUp() {
      try {
        const payload = new FormData();
        payload.append("id", this.followup_id);
        payload.append("patient_id", this.patient_id);
        payload.append("date", this.newFollowUpDate);
        payload.append("complaints", this.newFollowUpComplaints);
        payload.append("therapy", this.newFollowUpTherapy);
        payload.append("technique", this.newFollowUpTechnique);
        payload.append("observation", this.newFollowUpObservation);
        payload.append("duration", this.newFollowUpDuration);

        const response = await axios.post("/update-psycho-patient-followup", payload);
        if (response.status == 200) {
          this.$bvModal.hide("followup-detail");
          Swal.fire({
            title: "Success!",
            text: "Follow up updated successfully",
            icon: "success",
            confirmButtonColor: "#556ee6",
            timer: 2000,
            showConfirmButton: true,
          });
          await this.loadFollowUpData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to update follow up",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Delete follow up
    async deleteFollowUp(followupId) {
      try {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#556ee6",
          confirmButtonText: "Yes, delete it!",
        });

        if (!result.isConfirmed) return;

        const payload = new FormData();
        payload.append("id", followupId);

        const response = await axios.post("/delete-psycho-patient-followup", payload);
        if (response.status == 200) {
          Swal.fire({
            title: "Deleted!",
            text: "Follow up has been deleted.",
            icon: "success",
            confirmButtonColor: "#556ee6",
          });
          await this.loadFollowUpData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to delete follow up",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Get follow up number
    getFollowUpNumber(index) {
      return index + 1;
    },

    // Load End of Cycle tab data
    async loadEndOfCycleData() {
      if (!this.patient_id) return;

      try {
        const response = await axios.get(`/psycho-patient-end-of-cycle/${this.patient_id}`);
        const rawEndOfCycle = response.data || {};
        const endOfCycleData = Object.prototype.hasOwnProperty.call(rawEndOfCycle, "end_of_cycle")
          ? rawEndOfCycle.end_of_cycle
          : rawEndOfCycle;
        const hasEndOfCycleData = !!(endOfCycleData && Object.keys(endOfCycleData).length);
        this.showEndOfCycleForm = this.showEndOfCycleForm || hasEndOfCycleData;

        if (hasEndOfCycleData) {
          this.progress = endOfCycleData.progress || 0;
          this.engagement = endOfCycleData.engagement || 0;
          this.synthesis_notes = endOfCycleData.synthesis_notes || "";
        }
      } catch (error) {
        Swal.fire("Error loading end of cycle data:", error);
      }
    },

    async AddEndOfCycle() {
      try {
        const payload = new FormData();
        payload.append("id", this.patient_id);
        payload.append("progress", this.progress);
        payload.append("engagement", this.engagement);
        payload.append("synthesis_notes", this.synthesis_notes);

        const response = await axios.post("/update-psycho-patient-end-of-cycle", payload);
        if (response.status == 200) {
          this.showEndOfCycleForm = true;
          Swal.fire({
            title: "Success!",
            text: "End of cycle data saved successfully",
            icon: "success",
            confirmButtonColor: "#34c38f",
            showConfirmButton: true,
          });
          // Reload end of cycle data to reflect changes
          await this.loadEndOfCycleData();
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to save end of cycle data",
          icon: "error",
          confirmButtonColor: "#f46a6a",
          showConfirmButton: true,
        });
      }
    },

    // Load Patient Logs
    async loadPatientLogs() {
      if (!this.patient_id) return;

      try {
        this.isLoadingLogs = true;
        const response = await axios.get(`/psycho-patient-logs/${this.patient_id}`);
        this.patientLogs = response.data.logs || [];
      } catch (error) {
        Swal.fire("Error loading patient logs:", error);
      } finally {
        this.isLoadingLogs = false;
      }
    },

    // Reset log filters
    resetLogFilters() {
      this.logFilterModule = '';
      this.logFilterAction = '';
    },

    // Log helper methods
    getModuleName(module) {
      const modules = {
        1: 'Presentation',
        2: 'Assessment',
        3: 'Treatment',
        4: 'Therapeutic Plan',
        5: 'Follow up',
        6: 'End of Cycle'
      };
      return modules[module] || 'Unknown';
    },

    getModuleIcon(module) {
      const icons = {
        1: 'mdi mdi-card-account-details',
        2: 'mdi mdi-clipboard-check',
        3: 'mdi mdi-medical-bag',
        4: 'mdi mdi-calendar-check',
        5: 'mdi mdi-chart-line',
        6: 'mdi mdi-flag-checkered'
      };
      return icons[module] || 'mdi mdi-file-document';
    },

    getModuleClass(module) {
      const classes = {
        1: 'marker-presentation',
        2: 'marker-assessment',
        3: 'marker-treatment',
        4: 'marker-therapeutic',
        5: 'marker-followup',
        6: 'marker-endcycle'
      };
      return classes[module] || '';
    },

    getModuleBadgeClass(module) {
      const classes = {
        1: 'badge-soft-primary',
        2: 'badge-soft-info',
        3: 'badge-soft-warning',
        4: 'badge-soft-success',
        5: 'badge-soft-purple',
        6: 'badge-soft-dark'
      };
      return classes[module] || 'badge-soft-secondary';
    },

    getActionBadgeClass(action) {
      if (action === 'Created') return 'badge-soft-success';
      if (action === 'Updated') return 'badge-soft-info';
      if (action === 'Deleted') return 'badge-soft-danger';
      return 'badge-soft-secondary';
    },

    getActionBorderClass(action) {
      if (action === 'Created') return 'border-success';
      if (action === 'Updated') return 'border-info';
      if (action === 'Deleted') return 'border-danger';
      return '';
    },

    // Helper methods
    getPhotos(photoPath) {
      return photoPath ? `${axios.defaults.baseURL}${photoPath}` : '';
    },


  },
  created() {
    this.loadPatientBio()
  },

};
</script>

<style scoped>
.patient-bio {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.patient-bio-photo {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  object-fit: cover;
  margin-bottom: 0.5rem;
}

.patient-bio-row {
  display: grid;
  grid-template-columns: minmax(90px, 42%) 1fr;
  gap: 0.75rem;
  align-items: start;
  padding-bottom: 0.35rem;
  border-bottom: 1px dashed #e9ecef;
}

.patient-bio-row:last-child {
  border-bottom: none;
}

.patient-bio-label {
  color: #2c2f31;
  font-size: 0.8rem;
  /* text-transform: uppercase; */
  letter-spacing: 0.02em;
}

.patient-bio-value {
  font-size: 0.9rem;
  word-break: break-word;
}

.siblings-value {
  cursor: pointer;
}

.assessment-score-container {
  padding: 0.5rem 0;
}

.badge {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.badge:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.phq-group {
  background-color: #f0f9f7;
  padding: 0.75rem;
  border-radius: 0.5rem;
  border-left: 4px solid #198754;
}

.gad-group {
  background-color: #fffbf0;
  padding: 0.75rem;
  border-radius: 0.5rem;
  border-left: 4px solid #ffc107;
}

.group-label {
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2c2f31;
}

.phq-group .group-label {
  color: #0f5132;
}

.gad-group .group-label {
  color: #664d03;
}

.therapy-highlighted {
  background-color: #d1f3d1 !important;
}

.therapy-highlighted:hover {
  background-color: #c8e8c8 !important;
}

/* B-table styling for therapy sessions */
::v-deep .table-sm td,
::v-deep .table-sm th {
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
}

::v-deep .table-sm thead th {
  padding: 0.5rem 0.5rem;
  vertical-align: middle;
}

::v-deep .table td .btn {
  padding: 0.15rem 0.3rem;
  vertical-align: middle;
}

::v-deep .table td .btn i {
  vertical-align: middle;
}

@media (max-width: 768px) {
  .patient-bio-row {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }

  .phq-group,
  .gad-group {
    padding: 0.5rem;
  }
}

/* Activity Timeline Styles */
.activity-timeline {
  position: relative;
  padding-left: 2rem;
}

.activity-timeline::before {
  content: '';
  position: absolute;
  left: 1rem;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #e9ecef 0%, #e9ecef 100%);
}

.timeline-item {
  position: relative;
  padding-bottom: 1.5rem;
}

.timeline-marker {
  position: absolute;
  left: -1.5rem;
  top: 0.5rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 3px solid;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.timeline-marker i {
  font-size: 0.9rem;
  color: white;
}

.marker-presentation {
  background: linear-gradient(135deg, #556ee6 0%, #3b54d8 100%);
  border-color: #556ee6 !important;
}

.marker-assessment {
  background: linear-gradient(135deg, #50a5f1 0%, #3a8fd9 100%);
  border-color: #50a5f1 !important;
}

.marker-treatment {
  background: linear-gradient(135deg, #f1b44c 0%, #d99f3a 100%);
  border-color: #f1b44c !important;
}

.marker-therapeutic {
  background: linear-gradient(135deg, #34c38f 0%, #28a573 100%);
  border-color: #34c38f !important;
}

.marker-followup {
  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  border-color: #9b59b6 !important;
}

.marker-endcycle {
  background: linear-gradient(135deg, #50586c 0%, #3c4252 100%);
  border-color: #50586c !important;
}

.timeline-content {
  margin-left: 2rem;
}

.timeline-card {
  background: white;
  border: 2px solid #e9ecef;
  border-left: 4px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.logs-scroll {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.logs-scroll::-webkit-scrollbar {
  width: 6px;
}

.logs-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(116, 120, 141, 0.4);
  border-radius: 4px;
}

.logs-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.compact-log {
  padding: 0.6rem 0.75rem;
}

.compact-log .timeline-header {
  margin-bottom: 0.25rem;
}

.compact-log .log-inline {
  font-size: 0.85rem;
}

.compact-log-details {
  margin-top: 0.1rem;
  padding-top: 0;
  border-top: none;
}

.timeline-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateX(4px);
}

.timeline-card.border-success {
  border-left-color: #34c38f;
  background: linear-gradient(to right, #f0fdf7 0%, white 10%);
}

.timeline-card.border-info {
  border-left-color: #50a5f1;
  background: linear-gradient(to right, #f0f8ff 0%, white 10%);
}

.timeline-card.border-danger {
  border-left-color: #f46a6a;
  background: linear-gradient(to right, #fff5f5 0%, white 10%);
}

.log-description {
  padding: 0.5rem 0;
  font-size: 0.9rem;
  line-height: 1.5;
}

.log-description p {
  color: #495057;
}

.log-details {
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px dashed #e9ecef;
}

.badge-soft-primary {
  background-color: rgba(85, 110, 230, 0.18);
  color: #556ee6;
}

.badge-soft-info {
  background-color: rgba(80, 165, 241, 0.18);
  color: #50a5f1;
}

.badge-soft-warning {
  background-color: rgba(241, 180, 76, 0.18);
  color: #f1b44c;
}

.badge-soft-success {
  background-color: rgba(52, 195, 143, 0.18);
  color: #34c38f;
}

.badge-soft-danger {
  background-color: rgba(244, 106, 106, 0.18);
  color: #f46a6a;
}

.badge-soft-purple {
  background-color: rgba(155, 89, 182, 0.18);
  color: #9b59b6;
}

.badge-soft-dark {
  background-color: rgba(80, 88, 108, 0.18);
  color: #50586c;
}

.badge-soft-secondary {
  background-color: rgba(116, 120, 141, 0.18);
  color: #74788d;
}

@media (max-width: 768px) {
  .activity-timeline {
    padding-left: 1.5rem;
  }

  .timeline-marker {
    width: 1.75rem;
    height: 1.75rem;
    left: -1.25rem;
  }

  .timeline-marker i {
    font-size: 0.8rem;
  }

  .timeline-content {
    margin-left: 1.5rem;
  }
}
</style>
